<template>
  <div>
    <a-form-model
      :model="form"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      style="margin-top: 10px;"
      :rules="rules"
      ref="ruleForm"
    >
      <a-form-model-item label="Cơ quan ban hành" prop="title">
        <a-input v-model="form.title" placeholder="Nhập cơ quan ban hành..." />
      </a-form-model-item>
      <a-form-model-item label="Địa chỉ">
        <a-textarea
          v-model="form.address"
          placeholder="Nhập địa chỉ...."
          :auto-size="{ minRows: 3 }"
        />
      </a-form-model-item>
      <a-form-model-item label="Mô tả">
        <VueEditor
          class="ict24h-editor"
          :editor-toolbar="customToolbar"
          placeholder="Nhập mô tả..."
          v-model="form.description"
        />
      </a-form-model-item>
      <a-form-model-item label="Trạng thái">
        <a-switch
          @change="onChangeStatus"
          checked-children="Đang hoạt động"
          un-checked-children="Ngừng hoạt động"
          default-checked
        />
      </a-form-model-item>
    </a-form-model>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
    >
      <a-button style="margin-right: 10px;" @click="close">
        Đóng
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loading">
        Thêm mới
      </a-button>
    </div>
  </div>
</template>
<script>
import query from "../constant/query";

const rules = {
  title: [{ required: true, message: "Thông tin không được bỏ trống" }],
};
const defaultForm = { status: "ACTIVE" };
export default {
  props: {
    close: { type: Function, required: true },
    refreshAfterCreated: { type: Function, required: true },
  },
  data() {
    return {
      rules,
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      form: { status: "ACTIVE" },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" },
        ],
      ],
      loading: false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onCreatedDocumentAgencyIssued();
        } else {
          return false;
        }
      });
    },
    onCreatedDocumentAgencyIssued() {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: query.createDocumentAgencyIssued,
          variables: {
            ...this.form,
          },
        })
        .then(({ data }) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Thêm cơ quan ban hành thành công!",
          });
          this.loading = false;
          this.form = { ...defaultForm };
          if (data?.createDocumentAgencyIssued?.id) {
            this.refreshAfterCreated(data.createDocumentAgencyIssued);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Thêm cơ quan ban hành không thành công!",
          });
          console.log("Thêm cơ quan ban hành không thành công", err);
        });
    },
    onChangeStatus(check) {
      if (check) {
        this.$set(this.form, "status", "ACTIVE");
      } else {
        this.$set(this.form, "status", "DEACTIVE");
      }
    },
  },
};
</script>
<style scoped>
.ict24h-editor >>> .ql-toolbar.ql-snow {
  padding: 2px !important;
}
</style>
